<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraPromocaoAgente />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraPromocaoAgente from "../Components/Leituras/LeituraPromocaoAgente.vue";
export default {
  name: "ReadPromo",
  components: {
    LeituraPromocaoAgente,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>